import Image from 'next/image';

import { Box, Text } from '@zillow/constellation-10';

import PremiumBadge from '../../../../assets/premium-badge.png';

type Props = {
  isPremiumListing: boolean;
  headingText: string;
};

export function ListingModuleHeading({ isPremiumListing, headingText }: Props) {
  return (
    <Box css={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      {isPremiumListing && (
        <Image src={PremiumBadge} alt="premium badge" width={0} height={0} style={{ width: '35px', height: 'auto' }} />
      )}
      <Text
        className="ConnectedCard-Heading"
        asChild
        css={{
          marginRight: { base: '200', lg: '400' },
          textStyle: { base: 'body-bold', lg: 'heading-xs' },
        }}
      >
        <h2>{headingText}</h2>
      </Text>
    </Box>
  );
}
